/**
 * How Clerk's sign-up / sign-in forms look (16 Oct 2026, mobile design “Create your account”).
 *
 * Everywhere: our purple, 12px corners, 48px fields, a 52px primary button. On a phone the form is
 * the page itself — no card, no shadow, full width — and Clerk's footer (“Already have an account?
 * Sign in · Secured by Clerk”) sits at the bottom of the screen as a grey band. Our own logo is shown
 * above the form, so Clerk's is hidden.
 */
import type { ComponentProps } from 'react'
import type { SignUp } from '@clerk/clerk-react'

type Appearance = NonNullable<ComponentProps<typeof SignUp>['appearance']>

const PURPLE = '#7A3BD9'

export function authAppearance(phone: boolean): Appearance {
  const shared: Appearance = {
    variables: { colorPrimary: PURPLE, borderRadius: '12px', fontSize: '15px', colorText: '#1C1A22', colorTextSecondary: '#6B6775' },
    elements: {
      logoBox: { display: 'none' },
      headerTitle: { fontSize: '26px', fontWeight: 700, letterSpacing: '-.01em' },
      headerSubtitle: { fontSize: '15.5px', lineHeight: 1.5, color: '#6B6775' },
      socialButtonsBlockButton: { height: '52px', borderRadius: '12px', borderColor: '#E3E0E8', fontSize: '15.5px', fontWeight: 600 },
      socialButtonsBlockButtonText: { fontSize: '15.5px', fontWeight: 600 },
      formFieldLabel: { fontSize: '14.5px', fontWeight: 600, color: '#1C1A22' },
      formFieldInput: { height: '48px', borderRadius: '12px', fontSize: '15.5px' },
      formButtonPrimary: { height: '52px', borderRadius: '12px', fontSize: '16px', fontWeight: 600, textTransform: 'none', backgroundColor: PURPLE, boxShadow: 'none' },
      footerActionLink: { color: PURPLE, fontWeight: 600 },
    },
  }
  if (!phone) return shared
  return {
    ...shared,
    elements: {
      ...shared.elements,
      rootBox: { width: '100%' },
      // The form IS the page: full width, no frame, and the footer pushed to the bottom.
      cardBox: { width: '100%', maxWidth: '100%', boxShadow: 'none', border: 'none', borderRadius: 0, minHeight: 'calc(100dvh - 76px)', display: 'flex', flexDirection: 'column' },
      card: { boxShadow: 'none', border: 'none', borderRadius: 0, padding: '8px 20px 28px', flex: '1 1 auto', gap: '24px' },
      footer: { background: '#F7F7FA', borderRadius: 0, marginTop: 'auto', paddingBottom: 'max(12px, env(safe-area-inset-bottom))' },
    },
  }
}
